import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { captureException } from '@sentry/react';
import { CrashPage } from 'app/components/CrashPage/CrashPage';
import { LoadingSpinner } from 'app/components/Loading/Loading';
import { Links, Meta, Outlet, Scripts, ScrollRestoration, useRouteError } from 'react-router';
export const Layout = t0 => {
  const $ = _c(9);
  const {
    children
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <head suppressHydrationWarning={true}><HeadMeta /><link href="/fonts/inter/inter.css" rel="stylesheet" /><Links /></head>;
    t2 = <noscript>You need to enable JavaScript to run this app.</noscript>;
    t3 = <script dangerouslySetInnerHTML={{
      __html: "\n          window.global = window;\n          (function(){\n            var isIExplorer = !!document.documentMode;\n            if (isIExplorer) {\n              window.location.assign(\"not-supported.html\")\n            }\n          })();"
    }} />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <div id="root">{children}</div>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ScrollRestoration />;
    t6 = <Scripts />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4) {
    t7 = <html lang="en">{t1}<body>{t2}{t3}{t4}{t5}{t6}</body></html>;
    $[7] = t4;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export const HydrateFallback = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LoadingSpinner variant="screen" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const ErrorBoundary = () => {
  const $ = _c(4);
  const error = useRouteError();
  let t0;
  let t1;
  if ($[0] !== error) {
    t0 = () => {
      if (error) {
        captureException(error);
      }
    };
    t1 = [error];
    $[0] = error;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CrashPage />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
const Root = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Outlet />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Root;
const HeadMeta = () => {
  const $ = _c(12);
  let t0;
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <meta charSet="utf-8" />;
    t1 = <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, maximum-scale=1, user-scalable=0" />;
    t2 = <ContentSecurityPolicy />;
    t3 = <meta property="og:url" content="https://app.shape.construction" />;
    t4 = <meta property="og:type" content="website" />;
    t5 = <meta property="og:title" content="Shape" />;
    t6 = <meta property="og:image" content="https://app.shape.construction/images/splashscreens/og-share-image.png" />;
    t7 = <meta property="og:site_name" content="Shape" />;
    t8 = <meta property="og:description" content="Shape is a place where construction teams can create, track and resolve issues seamlessly on mobile and desktop. Teams using Shape collaborate more effectively and close-out defects and safety issues faster and smarter!" />;
    t9 = <Meta />;
    t10 = <link rel="shortcut icon" href="/favicon.ico" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t10;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t0 = $[0];
    t1 = $[1];
    t10 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}<link rel="manifest" href={import.meta.env.DEV ? "/manifest.json" : "/manifest.webmanifest"} /><link rel="apple-touch-icon" sizes="144x144" href="/images/icons/main/maskable_icon_x144.png" /><link rel="apple-touch-icon" sizes="152x152" href="/images/icons/main/maskable_icon_x152.png" /><link rel="apple-touch-icon" sizes="167x167" href="/images/icons/main/maskable_icon_x167.png" /><link rel="apple-touch-icon" sizes="180x180" href="/images/icons/main/maskable_icon_x180.png" /><link rel="apple-touch-icon" sizes="384x384" href="/images/icons/main/maskable_icon_x384.png" /><link rel="apple-touch-icon" sizes="512x512" href="/images/icons/main/maskable_icon_x512.png" /><link rel="apple-touch-icon" href="/images/icons/maskable_icon_x512.png" /><link rel="apple-touch-startup-image" media="(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/images/splashscreens/iPad-12.9_-Pro(vertical)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/images/splashscreens/iPad-12.9_-Pro(horizontal)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/images/splashscreens/iPad-11_-Pro(vertical)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/images/splashscreens/iPad-11_-Pro(horizontal)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 820px) and (device-height: 1180px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/images/splashscreens/iPad-10.9_-4thGen(vertical)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 820px) and (device-height: 1180px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/images/splashscreens/iPad-10.9_-4thGen(horizontal)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/images/splashscreens/iPad-10.5_-Air(vertical)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/images/splashscreens/iPad-10.5_-Air(horizontal)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/images/splashscreens/iPad-10.2_(vertical)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/images/splashscreens/iPad-10.2_(horizontal)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/images/splashscreens/iPad-9.7_-Pro(vertical)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/images/splashscreens/iPad-9.7_-Pro(horizontal)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)" href="/images/splashscreens/iPhone-14__iPhone-13-Pro__iPhone-13__iPhone-12-Pro__iPhone-12(landscape)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" href="/images/splashscreens/iPhone-14__iPhone-13-Pro__iPhone-13__iPhone-12-Pro__iPhone-12(portrait)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)" href="/images/splashscreens/iPhone-14-Plus__iPhone-13-ProMax__iPhone-12-ProMax(landscape)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" href="/images/splashscreens/iPhone-14-Plus__iPhone-13-ProMax__iPhone-12-ProMax(portrait)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 430px) and (device-height: 932px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)" href="/images/splashscreens/iPhone-14-ProMax(landscape)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 430px) and (device-height: 932px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" href="/images/splashscreens/iPhone-14-ProMax(portrait)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 393px) and (device-height: 852px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)" href="/images/splashscreens/iPhone-14-Pro(landscape)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 393px) and (device-height: 852px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" href="/images/splashscreens/iPhone-14-Pro(portrait)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" href="/images/splashscreens/iPhone-12-mini(vertical)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/images/splashscreens/iPhone-11(vertical)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" href="/images/splashscreens/iPhone-11-Pro-Max(vertical)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)" href="/images/splashscreens/iPhone-8-Plus(vertical)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/images/splashscreens/iPhone-8(vertical)_shape_splashscreen.png" /><link rel="apple-touch-startup-image" media="(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)" href="/images/splashscreens/iPhone-SE(vertical)_shape_splashscreen.png" /></>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
};

// Load and render csp config when building index.html
const contentSecurityPolicy = import.meta.env.SSR ? await import('../config/csp').then(csp => csp.getContentSecurityPolicy()) : undefined;
export const ContentSecurityPolicy = () => {
  const $ = _c(1);
  if (!contentSecurityPolicy) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <meta httpEquiv="Content-Security-Policy" content={contentSecurityPolicy} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};